export const titleObj = {
  about: {
    main: '嗨支付 让支付嗨起来',
    sub: '全新的支付理念，让支付更有效率',
    image: 'about_title_bg'
  },
  system: {
    main: '支付系统',
    sub: '全新的支付理念，让支付更有效率',
    image: 'system_title_bg'
  },
  case: {
    main: '业界成功案例',
    sub: '我们的产品实力深受业界肯定！',
    image: 'case_title_bg'
  },
  contact: {
    main: '联系我们',
    sub: '我们用心解决每位用户的问题',
    image: 'contact_title_bg'
  }
}

export const footerObj = [
  {
    type: 'Skype',
    id: 'live:.cid.5e15558205a7f6bd'
  },
  {
    type: 'Telegram',
    id: '@hihipay888'
  },
  {
    type: 'QQ客服',
    id: '1148563855'
  },
  {
    type: '客服邮箱',
    id: 'service@hihipay.net'
  }
]

export const systemObj = {
  payArr: ['wxpay', 'alipay', 'unionpay', 'qpay', 'jdpay', 'cloudpay'],
  flowObj: [
    {
      title: '可接入平台',
      text: '菠菜娱乐、彩票棋牌、影视娱乐,等平台'
    },
    {
      title: '联系客服',
      text: '在线咨询,留言提供您的信息'
    },
    {
      title: '商务洽谈',
      text: '三个工作日内专人联系确认费率方案'
    },
    {
      title: '技术对接',
      text: '双方技术部门对接接入Hipay支付系統'
    },
    {
      title: '正式上线',
      text: '测试验收完毕正式开通服务'
    }
  ]
}
